import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Después del pago recibís un correo con acceso inmediato a los 6 tomos + 6 bonos en formato PDF. Descargás y ya podés usarlos.'
}, {
  q: '¿Sirve para profesores particulares y para escuelas?',
  a: 'Sí. Está diseñado para funcionar en ambos contextos: tanto para el profesor autónomo que da clases en una pileta como para coordinadores de academias con múltiples grupos.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Ambas opciones incluyen los 6 bonos completos sin costo adicional.'
}, {
  q: '¿Sirve si soy profesor nuevo?',
  a: 'Sí. El sistema fue diseñado para que cualquier profesor pueda abrir el tomo y dar una clase correcta desde el primer día. La progresión pedagógica está explicada de forma clara y aplicable.'
}, {
  q: '¿Qué hago con alumnos de distintos niveles en el mismo grupo?',
  a: 'El Bono 3 (Banco de Variaciones Instantáneas) resuelve exactamente eso: cualquier ejercicio en 3 niveles simultáneos sin cambiar la planificación.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de natación?',
  a: 'La mayoría de los recursos de natación son teóricos o dan ejercicios sueltos sin progresión. El Megapack es un sistema completo: objetivo por sesión, minutaje, criterios de evaluación, checklists de avance y plan anual. Todo conectado.'
}, {
  q: '¿Por qué elegir el Combo con Natación Business Pro?',
  a: 'Porque el Megapack resuelve el qué enseñar. El Business Pro resuelve cómo retener alumnos, comunicar con padres, llenar carriles y cobrar lo que tu trabajo vale. Juntos son el sistema completo del profesor de natación profesional.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía completa. Si por cualquier razón no es lo que esperabas, devolvemos el 100% sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0A0A0F] py-12 px-4" data-id="element-39">
      <div className="max-w-2xl mx-auto" data-id="element-40">
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-6" data-id="element-41">
          Preguntas <span className="text-[#FF6B00]" data-id="element-42">Frecuentes</span>
        </h2>

        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl divide-y divide-[#FF6B0033] overflow-hidden" data-id="element-43">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} data-id="element-44">
                <button className="w-full text-left px-5 py-3.5 flex items-center justify-between gap-3" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-45">
                  <span className="text-white font-bold text-sm" data-id="element-46">{faq.q}</span>
                  <span className={`text-[#FF6B00] text-lg flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-47">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-5 pb-4 -mt-1" data-id="element-48">
                    <p className="text-[#B0B0C0] text-xs sm:text-sm leading-relaxed" data-id="element-49">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}